import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const professionsResolver: FieldResolver = (metadata: Metadata) =>
  ({ professions: metadata.getProfessions() } as StreamData)

export default professionsResolver
